(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gf-consignment-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gf-consignment-form')) {
    customElements.define('gf-consignment-form', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.input = this.querySelector('[data-gf-photo-input]');
        this.list = this.querySelector('[data-gf-photo-list]');
        this.summary = this.querySelector('[data-gf-photo-summary]');
        this.error = this.querySelector('[data-gf-consignment-error]');
        this.status = this.querySelector('[data-gf-consignment-status]');
        this.submitButton = this.querySelector('[data-gf-consignment-submit]');
        this.success = this.querySelector('[data-gf-consignment-success]');
        this.reference = this.querySelector('[data-gf-consignment-reference]');
        this.files = [];
        this.uploadedPhotos = new WeakMap();
        this.previewUrls = [];
        this.clientSessionId = this.restoreSessionId();
        this.session = null;
        this.sessionPromise = null;
        this.submitting = false;

        if (this.success) this.success.hidden = true;
        if (this.error) this.error.hidden = true;

        if (!this.form || !this.input || !this.submitButton) return;
        this.intentInput = this.form.elements['contact[intent]'];
        this.replyInput = this.form.elements['contact[preferred_contact]'];
        this.intentInput.addEventListener('change', () => this.updateIntent());
        this.replyInput.addEventListener('change', () => this.updateContactPreference());
        this.updateIntent();
        this.updateContactPreference();
        this.input.addEventListener('change', () => this.handleFiles());
        this.form.addEventListener('submit', event => this.handleSubmit(event));
      }

      updateIntent() {
        const intent = this.intentInput.value;
        const suffix = intent.charAt(0).toUpperCase() + intent.slice(1);
        const section = this.closest('.gf-consignment');
        section.querySelector('[data-gf-intake-heading]').textContent = this.dataset['heading' + suffix];
        this.submitButton.textContent = this.dataset['submit' + suffix];
        this.querySelector('[data-gf-intake-disclaimer]').textContent = this.dataset['disclaimer' + suffix];
        section.querySelector('[data-gf-consignment-terms]').hidden = intent !== 'consign';
        this.querySelector('[data-gf-local-intake]').hidden = intent !== 'consign';
        const acknowledgment = this.form.elements['contact[local_intake_acknowledgment]'];
        acknowledgment.required = intent === 'consign';
        if (intent !== 'consign') acknowledgment.checked = false;
      }

      updateContactPreference() {
        const required = this.replyInput.value !== 'email';
        this.form.elements['contact[phone]'].required = required;
        this.querySelector('[data-gf-phone-required]').hidden = !required;
      }

      disconnectedCallback() {
        this.revokePreviews();
      }

      restoreSessionId() {
        const key = 'gfConsignmentClientSession';
        try {
          const existing = sessionStorage.getItem(key);
          if (existing) return existing;
          const created = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
          sessionStorage.setItem(key, created);
          return created;
        } catch (error) {
          return globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        }
      }

      createRequestId() {
        return globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      }

      async ensureSession() {
        if (this.session?.token && this.session.expiresAt > Date.now() + 30000) {
          return this.waitForSession(this.session);
        }
        if (!this.sessionPromise) {
          this.sessionPromise = this.sendRequest('createConsignmentSession', {
            clientSessionId: this.clientSessionId,
            website: this.form.elements.website?.value || ''
          }).then(data => {
            const session = {
              token: String(data.token || ''),
              issuedAt: Number(data.issuedAt) || Date.now(),
              expiresAt: Number(data.expiresAt) || 0
            };
            if (!session.token || session.expiresAt <= Date.now()) throw new Error(this.dataset.submitErrorMessage);
            if (this.session?.token && this.session.token !== session.token) {
              this.uploadedPhotos = new WeakMap();
            }
            this.session = session;
            return this.waitForSession(session);
          }).finally(() => {
            this.sessionPromise = null;
          });
        }
        return this.sessionPromise;
      }

      waitForSession(session) {
        const waitMs = Math.max(0, 1600 - (Date.now() - session.issuedAt));
        return new Promise(resolve => setTimeout(() => resolve(session), waitMs));
      }

      handleFiles() {
        this.clearError();
        const selected = Array.from(this.input.files || []);
        const maxPhotos = Number(this.dataset.maxPhotos) || 6;
        const maxFileBytes = Number(this.dataset.maxFileBytes) || 8388608;
        const imageTypes = {
          jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png',
          webp: 'image/webp', heic: 'image/heic', heif: 'image/heif'
        };
        const accepted = new Set(Object.values(imageTypes));

        for (const file of selected) {
          const type = file.type.toLowerCase() || imageTypes[file.name.match(/\.([^.]+)$/)?.[1].toLowerCase()];
          if (!accepted.has(type)) {
            this.showError(this.dataset.photoTypeMessage);
            continue;
          }
          if (file.size > maxFileBytes) {
            this.showError(this.dataset.photoSizeMessage);
            continue;
          }
          if (this.files.length >= maxPhotos) {
            this.showError(this.dataset.photoLimitMessage);
            break;
          }
          this.files.push(file.type ? file : new File([file], file.name, { type, lastModified: file.lastModified }));
        }
        this.input.value = '';
        this.renderFiles();
      }

      renderFiles() {
        this.revokePreviews();
        this.previewEvents = new AbortController();
        this.list.replaceChildren();
        const count = this.files.length;
        this.summary.textContent = count === 0
          ? this.dataset.photoEmpty
          : `${count} ${count === 1 ? this.dataset.photoSingular : this.dataset.photoPlural}`;

        this.files.forEach((file, index) => {
          const url = URL.createObjectURL(file);
          this.previewUrls.push(url);
          const item = document.createElement('li');
          item.className = 'gf-consignment__photo-item';
          const image = document.createElement('img');
          image.className = 'gf-consignment__photo-preview';
          image.addEventListener('error', () => image.remove(), { once: true, signal: this.previewEvents.signal });
          image.src = url;
          image.alt = '';
          const name = document.createElement('span');
          name.className = 'gf-consignment__photo-name';
          name.textContent = file.name;
          const remove = document.createElement('button');
          remove.className = 'gf-consignment__photo-remove';
          remove.type = 'button';
          remove.textContent = this.dataset.removeLabel;
          remove.addEventListener('click', () => {
            this.files.splice(index, 1);
            this.renderFiles();
          });
          item.append(image, name, remove);
          this.list.append(item);
        });
      }

      revokePreviews() {
        this.previewEvents?.abort();
        this.previewUrls.forEach(url => URL.revokeObjectURL(url));
        this.previewUrls = [];
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.submitting) return;
        this.clearError();
        if (!this.form.reportValidity()) return;

        const originalButtonText = this.submitButton.textContent;
        this.submitting = true;
        this.submitButton.disabled = true;
        try {
          this.setStatus(this.files.length ? this.dataset.preparingMessage : this.dataset.sendingMessage);
          const session = await this.ensureSession();
          const preparedPhotos = [];
          let totalBytes = 0;
          for (let index = 0; index < this.files.length; index++) {
            this.setStatus(`${this.dataset.preparingMessage} ${index + 1}/${this.files.length}`);
            const priorUpload = this.uploadedPhotos.get(this.files[index]);
            const photo = priorUpload || await this.preparePhoto(this.files[index]);
            totalBytes += photo.byteLength;
            preparedPhotos.push({ file: this.files[index], fileName: this.files[index].name, ...photo });
          }
          if (totalBytes > Number(this.dataset.maxTotalBytes)) {
            throw new Error(this.dataset.photoTotalMessage);
          }

          const photos = [];
          for (let index = 0; index < preparedPhotos.length; index++) {
            this.setStatus(`${this.dataset.uploadingMessage} ${index + 1}/${preparedPhotos.length}`);
            const prepared = preparedPhotos[index];
            const uploaded = prepared.fileId ? prepared : await this.sendRequest('uploadConsignmentPhoto', {
                clientSessionId: this.clientSessionId,
                sessionToken: session.token,
                slot: index,
                photo: {
                  fileName: prepared.fileName,
                  dataUrl: prepared.dataUrl
                }
              });
            this.uploadedPhotos.set(prepared.file, uploaded);
            photos.push({
              fileId: String(uploaded.fileId || ''),
              fileName: String(uploaded.fileName || prepared.fileName),
              byteLength: Number(uploaded.byteLength) || prepared.byteLength
            });
          }

          this.setStatus(this.dataset.sendingMessage);
          const fields = new FormData(this.form);
          const result = await this.sendRequest('submitConsignmentIntake', {
            clientSessionId: this.clientSessionId,
            sessionToken: session.token,
            website: fields.get('website') || '',
            intake: {
              intent: fields.get('contact[intent]'),
              location: fields.get('contact[location]') || '',
              preferredContact: fields.get('contact[preferred_contact]'),
              fullName: fields.get('contact[name]') || '',
              email: fields.get('contact[email]') || '',
              phone: fields.get('contact[phone]') || '',
              itemType: fields.get('contact[item_type]') || '',
              makeModelYear: fields.get('contact[make_model_and_year]') || '',
              condition: fields.get('contact[condition]') || '',
              estimatedValue: fields.get('contact[estimated_value]') || '',
              details: fields.get('contact[body]') || '',
              sourcePage: fields.get('contact[source_page]') || window.location.href,
              ownershipConfirmed: fields.get('contact[ownership_confirmation]') === 'Confirmed',
              localIntakeConfirmed: fields.get('contact[local_intake_acknowledgment]') === 'Confirmed'
            },
            photos
          });
          const intakeId = String(result.intakeId || '').trim();
          if (!intakeId) throw new Error(this.dataset.submitErrorMessage);
          this.form.hidden = true;
          this.reference.textContent = intakeId;
          this.success.hidden = false;
          this.success.focus();
          this.success.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.revokePreviews();
        } catch (error) {
          if (['CONSIGNMENT_SESSION_REQUIRED', 'CONSIGNMENT_AUTH_EXPIRED', 'CONSIGNMENT_SESSION_USED'].includes(error.code)) {
            this.session = null;
            this.uploadedPhotos = new WeakMap();
          }
          this.showError(error.message || this.dataset.submitErrorMessage);
        } finally {
          this.setStatus('');
          this.submitting = false;
          this.submitButton.disabled = false;
          this.submitButton.textContent = originalButtonText;
        }
      }

      async preparePhoto(file) {
        if (file.size <= 1572864 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type.toLowerCase())) {
          return { dataUrl: await this.readDataUrl(file), byteLength: file.size };
        }
        try {
          const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
          const scale = Math.min(1, 2200 / Math.max(bitmap.width, bitmap.height));
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(bitmap.width * scale));
          canvas.height = Math.max(1, Math.round(bitmap.height * scale));
          const context = canvas.getContext('2d', { alpha: false });
          context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
          bitmap.close();
          const blob = await new Promise((resolve, reject) => {
            canvas.toBlob(result => result ? resolve(result) : reject(new Error(this.dataset.photoSizeMessage)), 'image/jpeg', 0.82);
          });
          const chosen = blob.size < file.size ? blob : file;
          return { dataUrl: await this.readDataUrl(chosen), byteLength: chosen.size };
        } catch (error) {
          return { dataUrl: await this.readDataUrl(file), byteLength: file.size };
        }
      }

      readDataUrl(blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(String(reader.result || ''));
          reader.onerror = () => reject(new Error(this.dataset.photoSizeMessage));
          reader.readAsDataURL(blob);
        });
      }

      async sendRequest(action, data) {
        const requestId = this.createRequestId();
        const endpointValue = this.dataset.endpoint;
        if (!endpointValue) throw new Error(this.dataset.submitErrorMessage);
        const endpoint = new URL(endpointValue, window.location.origin);
        endpoint.searchParams.set('requestId', requestId);
        let response;
        try {
          response = await fetch(endpoint.toString(), {
            method: 'POST',
            redirect: 'follow',
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify({
              action,
              ...data,
              source: 'shopify_consignment_intake',
              requestId,
              clientSentAt: new Date().toISOString(),
              clientBuild: '2026-10-14-seller-inquiry'
            })
          });
        } catch (error) {
          throw new Error(this.dataset.serviceErrorMessage);
        }
        if (!response.ok) throw new Error(this.dataset.serviceErrorMessage);
        let json;
        try {
          json = await response.json();
        } catch (error) {
          throw new Error(this.dataset.serviceErrorMessage);
        }
        if (json.status === 'error') {
          const error = new Error(json.message || this.dataset.submitErrorMessage);
          error.code = String(json.code || '');
          throw error;
        }
        return json.data || {};
      }

      setStatus(message) {
        if (this.status) this.status.textContent = message;
      }

      clearError() {
        if (!this.error) return;
        this.error.hidden = true;
        this.error.textContent = '';
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message || this.dataset.submitErrorMessage;
        this.error.hidden = false;
        this.error.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-repair-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    const question = event.target.closest('.gf-repair__question');
    if (question) question.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
